import getVariantPrice from '@lib/util/getVariantPrice'
import { PricedVariant } from '@medusajs/medusa/dist/types/pricing'
import { PriceSelectionResult } from '@medusajs/medusa'

const findCheapestVariant = (variants: PricedVariant[]): PricedVariant => {
    let cheapestVariant: PricedVariant = variants[0]

    const variantPricesMap = new Map<string, PriceSelectionResult>()

    for (const variant of variants) {
        const variantPrice = getVariantPrice(variant.prices)
        variantPricesMap.set(variant.id!, variantPrice!)

        const cheapestVariantPrice = variantPricesMap.get(cheapestVariant.id!)

        if (variantPrice?.calculatedPrice && variantPrice.calculatedPrice < cheapestVariantPrice!.calculatedPrice!) {
            cheapestVariant = variant
        }
    }

    return cheapestVariant
}

export default findCheapestVariant
